import { render } from "./ColorPalette.vue?vue&type=template&id=00537004&scoped=true"
import script from "./ColorPalette.vue?vue&type=script&lang=js"
export * from "./ColorPalette.vue?vue&type=script&lang=js"

import "./ColorPalette.vue?vue&type=style&index=0&id=00537004&lang=scss&scoped=true"
import "./ColorPalette.vue?vue&type=style&index=1&id=00537004&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00537004"]])

export default __exports__